export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";